import { gql } from '@apollo/client';

export const SET_LINK_MUTATION = gql`
  mutation switchTeams($targetAccountEmail: String!, $password: String) {
    switchTeams: linkAccount(targetAccountEmail: $targetAccountEmail, password: $password) {
      activeTeamPermission
      email
      activeTeamV2 {
        emailAddress
        id
        name
      }
    }
  }
`;

export const GET_LINK_ACCOUNT_QUERY = gql`
  query accountData {
    account: accountData {
      activeTeamPermission
      email
      isSSOAuthenticated
      activeTeamV2 {
        emailAddress
        id
        name
      }
      teamsV2 {
        emailAddress
        id
        name
      }
    }
  }
`;
